import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
} from 'react-bootstrap';
import BidSendForm from './BidSendForm';


function formatContactData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    value: item.id,
  }));
}


class BidSendModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showPopUp:false,
      newContactsList:null,
    }
    this.send = this.send.bind(this);
    this.ContactPopUpShow = this.ContactPopUpShow.bind(this);
    this.ContactPopupHide = this.ContactPopupHide.bind(this);
    this.updateMergeValue = this.updateMergeValue.bind(this);
  }
  send(values) {
    console.log("values.......................",values)
    this.props.sendBid(this.props.bid.id, values);
    this.props.close();
  }
  ContactPopUpShow(){
    this.setState({showPopUp:true});
  }
  ContactPopupHide(){
    this.setState({showPopUp:false});
  }
  updateMergeValue(value){
    if(value==null){
      this.setState({newContactsList:null})
    } else{
      this.setState({newContactsList:value})
    }
  }
  render() {
    const updateContact = (id,val)=>{
      let name = val.name;
      let email = val.email;
      let user = val.id;
      const newContact =[];
      if(id=='update'){
        let name_val = name.split(" ");
        this.props.bid.hotel.contacts.map((val)=>{
          if(val.id==user){
            val.first_name = name_val[0];
            val.last_name = name_val[1];
            val.email = email;
          }
          newContact.push(val)
        })
      }
      if(id=='delete'){
        this.props.bid.hotel.contacts.map((val)=>{
          if(val.id==user){
            console.log("contact deleted")
          } else{
            newContact.push(val)
          }
        })
      }
      if(newContact.length==0){
        return null;
      } else{
        return newContact
      }
    }
    const newContact = this.state.newContactsList?this.state.newContactsList:this.props.bid.hotel.contacts;
    const contactOptions = formatContactData(newContact);
    return (
      <Modal show={this.props.show} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Assign to Property</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Assign the bid to an existing user or invite a new user.</p>
          <BidSendForm
            onSubmit={this.send}
            options={contactOptions}
            handleClose={this.props.close}
            showPopUp={this.state.showPopUp}
            ContactPopUpShow={this.ContactPopUpShow}
            ContactPopupHide={this.ContactPopupHide}
            bid={this.props.bid}
            updateHotelContacts={this.props.updateHotelContacts}
            deleteHotelContacts={this.props.deleteHotelContacts}
            updateContact={updateContact}
            updateMergeValue={this.updateMergeValue}
            loginUser={this.props.user}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}


BidSendModal.propTypes = {
  bid: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
};

BidSendModal.defaultProps = {
  bid: {
    contacts: [],
  },
};
export default BidSendModal;



// WEBPACK FOOTER //
// src/routes/booking/components/BidSendModal.js